import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core'
import { CONTENT_TYPE, SOURCE_TYPE, LANGUAGES, BOOLEAN_OPTIONS } from '../../Features/AddNewLTDDocument/@types'
import FormGroup, { IFormConfig } from '../FormGroup'
import { TState } from '../../RootReducer'
import { ONewLTDDocument } from '../../Features/AddNewLTDDocument/redux-config'
import { OApp } from '../../RootReducer/AppReducer'
import _ from 'lodash';
import { connect } from 'react-redux'
import ChipSelect from '../ChipSelect'
import SearchAdd from '../SearchAdd'
import moment from 'moment'
import { orderByFeaturedList, LTD_FEATURED_LANGUAGES } from '../../Features/AddNewLTDDocument/addNewLegalFinding-reducer'
import { MENU_LIST_DATE_CREATED, MENU_LIST_TRANSLATED_TITLE, METADATA_ABSTRACT, METADATA_APPROXIMATE_DATE, METADATA_AUTHORIATIVE_LANGUAGE, METADATA_CONTENT_TYPE, METADATA_DATE_EXPIRY, METADATA_ENTERY_INTO_FORCE, METADATA_EXTERNAL_IDENTIFIER, METADATA_LANGUARE, METADATA_NOTES, METADATA_ORGANISATION_STATE_SOURCE, METADATA_ORIGINAL_LANGUAGE, METADATA_SHORT_TITLE, METADATA_SHORT_TITLE_EN, METADATA_SHORT_TITLE_FR, METADATA_SOURCE, METADATA_SOURCE_TYPE, METADATA_SOURCE_URL, METADATA_TITLE, METADATA_TRANSLATED_TITLE_FR } from '../../Features/Translations/translationKeys.ltd'
import { WithTranslationProps, withTranslations } from '../../Features/Translations/withTranslations'



interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps { }


interface IStateProps {
    formData: Record<string, any>
    appConstants: any
    includeIdOptions: Record<string, any>
}

interface IDispatchProps {
    setFormField: (key: string, value: any) => void
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => void,
    removeField: (key: string) => void
}

class BasicInformation extends Component<IProps & WithTranslationProps> {

    handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement | HTMLInputElement>) => {
        const { name, value } = e.target;
        if (this.props.setFormField) {
            this.props.setFormField(name, value);
            if (name === 'dateCreated') {
                this.props.setFormField('dateCreated_str', moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY'));
            }
        }
    }
    handleSourceTypeChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement | HTMLInputElement>) => {

        if (this.props.setFormField) {
            this.props.setFormField(e.target.name, [e.target.value])
        }
    }

    handleSlect = (key: string, value: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(key, value)
        }
    }

    handleSuggestion = ({ name, value }) => {
        this.props.setFormField(name, value);
    }



    render() {
        const { classes, formData, appConstants, includeIdOptions, getTranslation } = this.props;

        const FORM_CONFIG: IFormConfig[][] = [
            [
                { label: 'Content Type', key: 'contentType', type: 'select', onChange: this.handleChange, options: _.get(appConstants, 'contentType'), translationKey: METADATA_CONTENT_TYPE },
                { label: 'External identifier', key: 'externalId', type: 'text', onChange: this.handleChange, translationKey: METADATA_EXTERNAL_IDENTIFIER }
            ],
            [
                { label: 'Title', key: 'title', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_TITLE },
            ],
            [
                { label: 'Translated title (EN)', key: 'title_en', type: 'multiline', onChange: this.handleChange, translationKey: MENU_LIST_TRANSLATED_TITLE },
            ],
            [
                { label: 'Translated title (FR)', key: 'title_fr', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_TRANSLATED_TITLE_FR },
            ],
            [
                { label: 'Short title', key: 'shortTitle', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_SHORT_TITLE },
            ],
            [
                { label: 'Short title (EN)', key: 'shortTitle_en', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_SHORT_TITLE_EN },
            ],
            [
                { label: 'Short title (FR)', key: 'shortTitle_fr', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_SHORT_TITLE_FR },
            ],
            [
                {
                    label: 'Source', key: 'source', type: 'component', onChange: this.handleChange, translationKey: METADATA_SOURCE, component: (
                        <SearchAdd
                            value={formData['source'] || ''}
                            label={getTranslation(METADATA_SOURCE) || "Source"}
                            formKey="source"
                            key="source"
                            onChange={this.handleSuggestion}
                            suggestionUrl="ltddocs/autocomplete"
                            params={(term) => ({ term, field: 'source' })}
                            handleSuggestions={(data) => data.map(val => val['source'])}
                        />
                    )
                },
                { label: 'Source type', key: 'sourceTypeIds', type: 'select', onChange: this.handleSourceTypeChange, options: _.get(includeIdOptions, 'sourceTypes'), translationKey: METADATA_SOURCE_TYPE },
            ],
            [
                {
                    label: 'Organisation / State of Source', key: 'organisation', type: 'component', onChange: this.handleChange, translationKey: METADATA_ORGANISATION_STATE_SOURCE, component: (
                        <SearchAdd
                            label={getTranslation(METADATA_ORGANISATION_STATE_SOURCE) || "Organisation / State of Source"}
                            formKey="organisation"
                            key="organisation"
                            value={formData['organisation'] || ''}
                            onChange={this.handleSuggestion}
                            suggestionUrl="ltddocs/autocomplete"
                            params={(term) => ({ term, field: 'organisation' })}
                            handleSuggestions={(data) => data.map(val => val['organisation'])}
                        />
                    )
                },
                { label: 'Language(s)', key: 'languageIds', type: 'multiselect', translationKey: METADATA_LANGUARE, onChange: this.handleChange, options: orderByFeaturedList<{ name: string, value: string }>(_.get(includeIdOptions, 'languages'), LTD_FEATURED_LANGUAGES) },
            ],
            [
                {
                    label: '', key: '', type: 'component', onChange: this.handleChange,
                    component: (
                        <div className="flex-row space-between">
                            <ChipSelect formkey="isOriginalLanguage" value={formData['isOriginalLanguage']} title={getTranslation(METADATA_ORIGINAL_LANGUAGE) || 'Original language'} onChange={this.handleSlect} options={BOOLEAN_OPTIONS} />
                            <ChipSelect formkey="isAuthoritativeLanguage" value={formData['isAuthoritativeLanguage']} title={getTranslation(METADATA_AUTHORIATIVE_LANGUAGE) || 'Authoritative language'} onChange={this.handleSlect} options={BOOLEAN_OPTIONS} />
                        </div>
                    )
                },
                { label: 'Date created', key: 'dateCreated', type: 'date', onChange: this.handleChange, translationKey: MENU_LIST_DATE_CREATED },
            ],
            [
                { label: 'Approximate date', key: 'approximateDate', type: 'date', onChange: this.handleChange, translationKey: METADATA_APPROXIMATE_DATE },
                { label: 'Date of expiry', key: 'expiryDate', type: 'date', onChange: this.handleChange, translationKey: METADATA_DATE_EXPIRY },
            ],
            [
                { label: 'Entry into force', key: 'entryIntoForce', type: 'date', onChange: this.handleChange, translationKey: METADATA_ENTERY_INTO_FORCE },
                { label: 'Source URL', key: 'sourceUrl', type: 'text', onChange: this.handleChange, translationKey: METADATA_SOURCE_URL },
            ],
            [
                { label: 'Abstract', key: 'abstract', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_ABSTRACT },
            ],
            [
                { label: 'Notes', key: 'notes', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_NOTES },
            ],
        ]

        return (
            <>
                <FormGroup classes={{ root: classes.formContainer }} formData={formData} formItems={FORM_CONFIG} />
            </>
        )
    }
}

const STYLES = (theme: Theme) => createStyles({
    formContainer: {
        [theme.breakpoints.down('sm')]: {
            width: '95vw',
        }
    }
})


const mapStateToProps = (state: TState): IStateProps => ({
    ..._.pick(state.NewLTDDocument, ['formData']),
    appConstants: _.get(state.App, 'appConstants.LtdDoc'),
    includeIdOptions: _.get(state.App, 'ltdIncludeOptions'),

});

const mapDispatchToProps = (dispatch): IDispatchProps => ({
    setFormField: (k: string, v: any) => dispatch(ONewLTDDocument.setFormField(k, v)),
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => dispatch(OApp.showConfirmationDialog(msg, onConfirm, onCancel)),
    removeField: (key: string) => dispatch(ONewLTDDocument.removeField(key)),

})



export default withStyles(STYLES)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(BasicInformation)))